export default "__VITE_ASSET__Bb$VH9XS__"